import React from 'react';
import './style.scss';

export default ({ className='', ...props }) => <div className={`zt-miniloader ${className}`} {...props}>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
</div>